import {
    // SET_REQUEST,
    // SET_SELECTED_SUBTYPE_ID,
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUISITION_TYPE,
    SET_IREQUEST,
    SET_INON_STANDARD_EQUIPMENT,
    SET_IPRODUCTION_VEHICLE,
    SET_IREASON,
    SET_CART_IREQUEST,
    SET_CART_IPRODUCTION_VEHICLE,
    SET_CART_IREASON,
    SET_SHOW_ITEM_DETAILS,
    SET_IS_ADD_TO_CART_CLICK,
    SET_IS_REASON_CHANGE,
    SET_IORDER_REQUEST,
    SET_IS_SUBMIT_CLICK,
    SET_IS_SAVE_CLICK,
    SET_ORDER_LEADR_NUMBER,
    SET_IS_ORDER_CREATION_SUCCESS,
    SET_ORDER_ID,
    SET_IS_EDIT_ORDER,
    SET_CART_INON_STANDARD_EQUIPMENT,
    SET_MANAGED_EQUIPMENT_VALUES,
    SET_IMANAGED_EQUIPMENT,
    SET_CART_IMANAGED_EQUIPMENT,
    SET_SELECTED_EQUIPMENT_TYPE,
    SET_CART_IMANAGEMENT_VEHICLE,
    SET_IMANAGEMENT_VEHICLE,
    SET_SELECTED_CATALOG_ITEM,
    SET_IS_CATALOG_ITEM_EXIST,
    SET_IS_CHANGES_OCCURED,
    SET_ISMAND_FLAG,
    SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED,
    SET_ORDER_EDIT_NAVIGATION_CHANGE,
    SET_IS_ADD_ASSET_CLICK,
    SET_IS_ADD_ITEM_CLICK,
    SET_EDIT_REQUEST_DETAILS,
    SET_IS_EDIT_REQUEST_CLICK,
    SET_IS_ADD_REQUISITION_TYPE_CLICK,
    SET_IS_UPDATE_SUCCESS_ALERT,
    SET_IS_APPROVAL_OVERRIDE_FLAG,
    SET_IS_DEALER_SAMEFORALL_FLAG

} from './RequisitionType';



const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_SELECTED_BRANCH:
            return {
                ...state,
                selectedBranch: action.selectedBranch,
            };
        case SET_SELECTED_REQUISITION_TYPE:
            return {
                ...state,
                selectedRequisitionType: action.selectedRequisitionType,
            };
        case SET_IREQUEST:
            return {
                ...state,
                requestList: action.requestList,
            };
        case SET_IMANAGEMENT_VEHICLE:
            return {
                ...state,
                managementVehicleList: action.managementVehicleList,
            };
        case SET_INON_STANDARD_EQUIPMENT:
            return {
                ...state,
                nonStandardEquipmentList: action.nonStandardEquipmentList,
            };
        case SET_IPRODUCTION_VEHICLE:
            return {
                ...state,
                productionVehicleList: action.productionVehicleList,
            };
        case SET_IREASON:
            return {
                ...state,
                reasonList: action.reasonList,
            };
        case SET_CART_IREQUEST:
            return {
                ...state,
                requestCartList: action.requestList,
            };
        case SET_CART_IPRODUCTION_VEHICLE:
            return {
                ...state,
                productionVehicleCartList: action.productionVehicleList,
            };
        case SET_CART_INON_STANDARD_EQUIPMENT:
            return {
                ...state,
                nonStandardEquipmentCartList: action.nonStandardEquipmentList,
            };
        case SET_CART_IMANAGEMENT_VEHICLE:
            return {
                ...state,
                managementVehicleCartList: action.managementVehicleList,
            };
        case SET_CART_IREASON:
            return {
                ...state,
                reasonCartList: action.reasonList,
            };
        case SET_SHOW_ITEM_DETAILS:
            return {
                ...state,
                showItemDetails: action.showItemDetails,
            };
        case SET_IS_ADD_TO_CART_CLICK:
            return {
                ...state,
                isAddToCartClick: action.isAddToCartClick,
            };
        case SET_IS_REASON_CHANGE:
            return {
                ...state,
                isReasonChange: action.isReasonChange,
            };
        case SET_IORDER_REQUEST:
            return {
                ...state,
                orderRequest: action.orderRequest
            }
        case SET_IS_SUBMIT_CLICK:
            return {
                ...state,
                isSubmitClick: action.isSubmitClick
            }
        case SET_IS_SAVE_CLICK:
            return {
                ...state,
                isSaveClick: action.isSaveClick
            }
        case SET_ORDER_LEADR_NUMBER:
            return {
                ...state,
                leadrNumber: action.leadrNumber
            }
        case SET_IS_ORDER_CREATION_SUCCESS:
            return {
                ...state,
                isOrderCreationSuccess: action.isOrderCreationSuccess
            }
        case SET_ORDER_ID:
            return {
                ...state,
                orderId: action.orderId
            }
        case SET_IS_EDIT_ORDER:
            return {
                ...state,
                isEditOrder: action.isEditOrder
            }
        case SET_IMANAGED_EQUIPMENT:
            return {
                ...state,
                managedEquipmentList: action.managedEquipmentList,
            };
        case SET_CART_IMANAGED_EQUIPMENT:
            return {
                ...state,
                managedEquipmentCartList: action.managedEquipmentCartList,
            };
        case SET_MANAGED_EQUIPMENT_VALUES:
            return {
                ...state,
                managedEquipmentValues: action.managedEquipmentValues,
            };
        case SET_SELECTED_EQUIPMENT_TYPE:
            return {
                ...state,
                selectedEquipmentType: action.selectedEquipmentType,
            };
        case SET_SELECTED_CATALOG_ITEM:
            return {
                ...state,
                selectedCatalogItem: action.selectedCatalogItem,
            };
        case SET_IS_CATALOG_ITEM_EXIST:
            return {
                ...state,
                isCatalogItemExist: action.isCatalogItemExist,
            };
        case SET_IS_CHANGES_OCCURED:
            return {
                ...state,
                isChangesOccured: action.isChangesOccured,
            };
        case SET_ISMAND_FLAG:
            return {
                ...state,
                isMandAFlag: action.IsMandAFlag
            }
        case SET_IS_APPROVAL_OVERRIDE_FLAG:
            return {
                ...state,
                isApprovalOverrideFlag: action.isApprovalOverrideFlag
            }    
        case SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED:
            return {
                ...state,
                productionVehicleDangerouslySetExpandedList: action.ProductionVehicleDangerouslySetExpandedList,
            }
        case SET_ORDER_EDIT_NAVIGATION_CHANGE:
                return {
                    
                    ...state,
                    orderEditNavigateChange: action.orderEditNavigateChange,
                };
        
        case SET_IS_ADD_ASSET_CLICK:
                return {
                    ...state,
                    isAddAssetclick : action.isAddAssetclick,
                }        
        case SET_IS_ADD_ITEM_CLICK:
                return {
                    ...state,
                    isAddItemclick : action.isAddItemclick,        
                }       
        case SET_EDIT_REQUEST_DETAILS:
                return {
                    ...state,
                    editRequestDetails : action.editRequestDetails,
                }    
        case SET_IS_EDIT_REQUEST_CLICK:
                return {
                    ...state,
                    isEditRequestClick : action.isEditRequestClick,
                }     
        case SET_IS_ADD_REQUISITION_TYPE_CLICK:
                return {
                    ...state,
                    isAddRequistionTypeClick : action.isAddRequistionTypeClick,
                }  
        case SET_IS_UPDATE_SUCCESS_ALERT:
                return {
                    ...state,
                    isUpdateSuccessAlert : action.isUpdateSuccessAlert,
                }     
        case SET_IS_DEALER_SAMEFORALL_FLAG:
            return {
                ...state,
                isDealerSameForAllFlag : action.isDealerSameForAllFlag,
            }                      
        default:
            return state;
    }
}

export {
    reducers
}
